module.exports = __webpack_public_path__ + "static/media/arrow-svgrepo-com (1).b3069f0e.svg";